module.exports = __webpack_public_path__ + "img/kuro.e9d7e7d4.jpg";